import {
  SET_BALANCED_DELIVERIES,
  SET_PROBLEMATIC_DELIVERIES,
  SET_PUNCTUAL_DELIVERIES,
  SET_UNASSIGNED_TASKS,
  SET_ACTIONS,
  TOGGLE_UPLOADMODAL
} from '../actions/types';

const initialState = {
  actions: [],
  problems: [],
  upload: false,
  unassigned: 0,
  punctual: {
    target: 0,
    actual: 0,
    total: 0
  },
  balanced: {
    target: 0,
    actual: 0,
    total: 0
  }
};

export default function (state = initialState, action) {
  switch (action.type) {
  case SET_ACTIONS:
    return {
      ...state,
      actions: action.data
    };
  case TOGGLE_UPLOADMODAL:
    return {
      ...state,
      upload: action.status
    };
  case SET_UNASSIGNED_TASKS:
    return {
      ...state,
      unassigned: action.data
    };
  case SET_BALANCED_DELIVERIES:
    return {
      ...state,
      balanced: action.data
    };
  case SET_PUNCTUAL_DELIVERIES:
    return {
      ...state,
      punctual: action.data
    };
  case SET_PROBLEMATIC_DELIVERIES:
    return {
      ...state,
      problems: action.data
    };
  default:
    return state;
  }
}
